<script>
    export let name;
    export let width = "2rem";
    export let height = "2rem";
    export let focusable = true;
    export let colour = "#000";

    // from Feather Icons (open-source): https://feathericons.com/ 
    let icons = [
        {
          box: 24,
          name: "nav-left",
          svg: `<g stroke=${colour} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></g>`
        },
        {
          box: 24,
          name: "nav-right",
          svg: `<g stroke=${colour} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></g>`
        }
    ];
    let displayIcon = icons.find((e) => e.name === name);
</script>
<svg
    fill="none"
    class={$$props.class}
    {focusable}
    {width}
    {height}
    viewBox="0 0 {displayIcon.box} {displayIcon.box}">
        {@html displayIcon.svg}
</svg>
